/* @flow */

import * as React from 'react';
import {Button} from '../button';
import {ChevronDownIcon, ChevronRightIcon} from '../../icon';

type Props = {
    isShown: boolean,
    onToggle: (newState: boolean) => void,
    count: number,
    pluralNoun: string,
    singularNoun: string,
};

export function ShowHideButton(props: Props) {
    return (
        <Button onClick={props.onToggle} variant='text-primary'>
            {props.isShown ? (
                <>
                    <span className='mr-4'>
                        {`Hide ${props.count} ${
                            props.count === 1 ? props.singularNoun : props.pluralNoun
                        }`}
                    </span>
                    <ChevronDownIcon size={11} />
                </>
            ) : (
                <>
                    <span className='mr-4'>
                        {`Show ${props.count} ${
                            props.count === 1 ? props.singularNoun : props.pluralNoun
                        }`}
                    </span>
                    <ChevronRightIcon size={11} />
                </>
            )}
        </Button>
    );
}
